import { EventGS, EventGSToken } from '../core/EventsGS';
import { WrapperGS } from '../core/WrapperGS';

export class DetailsGS extends WrapperGS<HTMLDetailsElement>
{
    static ForHTMLElement(el: HTMLElement): boolean {
        return el.nodeName.toLowerCase() === "details";
    }

    private readonly _onToggleToken: EventGSToken<Event>;
    public readonly onToggle: EventGS<Event>;

    constructor(el: HTMLDetailsElement|string)
    {
        super(el);
        this._onToggleToken = new EventGSToken<Event>(() => { this.el.addEventListener('toggle', e => this._onToggleToken.invoke(e)); });
        this.onToggle = new EventGS<Event>(this._onToggleToken);
    }

    public get open() { return this.el.open; }
    public set open(value: boolean) { this.el.open = value; }

    public toggle() { this.open = !this.open; }
}
WrapperGS.ExtendComponentsByHTMLElement(DetailsGS);
